import $ from 'jquery'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import constants from 'scoreboard/components/constants'
import icon from 'scoreboard/components/icon'

/**
 * Expander code which works in tandem with datasets-edit.scss to expand and collapse
 * .permissions-panel tables based on whether they exceed maxRows
 *
 * @param {Object} table the DOM element corresponding to the table which is to be
 * expanded or collapsed.
 * @param {Boolean} isCollapsed false if the table should start out expanded, default to true
 */

class DatasetsTableExpander {
	constructor(options = {}) {
		this.options = options
		_.bindAll(this, 'toggleExpandTable')
	}

	setup() {
		var {
			table,
			isCollapsed = !table.hasClass('is-expanded')
		} = this.options

		this.table = table

		table.toggleClass('is-expanded', !isCollapsed)

		this.table.next('.expand-collapse-row').remove()
		if (this.table.find('tbody tr').length > this.options.maxRows &&
			_.isNil(this.expandCollapseRow)) {

			let expandCollapseHtml =
				'<div class="expand-collapse-row"><span class="content">' +
				icon('collapsed') +
				`<span class="expand">${i18n.get('common.expand')}</span>` +
				`<span class="collapse">${i18n.get('common.collapse')}</span>` +
				`</span><div>`

			this.expandCollapseRow = $(expandCollapseHtml)
			this.table.after(this.expandCollapseRow)
			this.expandCollapseRow.on('click', this.toggleExpandTable)
		}

		return this
	}

	_isExpanded() {
		return this.table.hasClass('is-expanded')
	}

	scrollIntoView(el, topAdjust = 0) {
		let containerTop = this.options.scrollContainer.scrollTop()
		let rowTop = $(el).offset().top
		let scrollTop = containerTop + rowTop - topAdjust
		// don't use scrollIntoView() here because IE has trouble with that #26449
		this.options.scrollContainer.scrollTop(scrollTop)
	}

	getRow(selector) {
		return this.table.find(selector)
	}

	// Handle a table's expanding and collapsing based on how many rows are present
	// or maxRows
	toggleExpandTable(expand) {
		if (!(expand instanceof $.Event) && expand && this._isExpanded()) {
			return
		}

		// Nix the click handlers here so we can reset them below
		this.table.find('tr').off('click', this.toggleExpandTable)

		// We're going to collapse the table
		if (this._isExpanded()) {
			this.table.removeClass('is-expanded')

			// If we're collapsing the table and it's containing panel is partially
			// scrolled out of view to the top, manually scroll the page back up
			// in order to keep the recently collapsed table in view and, therefore,
			// keep less confusing
			// https://github.com/SpiderStrategies/Scoreboard/issues/26449#issuecomment-558357935
			let panel = this.table.closest('.panel')
			if (panel.position().top < constants.STANDARD_MARGIN*-1) {
				this.scrollIntoView(panel)
			}
		// We're going to expand the table
		} else {
			this.table.addClass('is-expanded')
		}

		_.result(this.options, 'onToggleExpandTable')
	}

	remove() {
		this.table.find('tr').off('click', this.toggleExpandTable)
	}
}

export default DatasetsTableExpander

DatasetsTableExpander.__filename__ = 'datasets/edit/datasets-table-expander.js'
